import { AfterContentInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { NgSelectComponent, NgSelectConfig, NgSelectModule } from '@ng-select/ng-select';
import { HelperService } from 'src/sb-tools/typescript/services/helper.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { SelectAccessibilityDirective } from '@form-field-module/common/directives/select-accessibility.directive';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'sb-store-info',
    templateUrl: './store-info.component.html',
    styleUrls: ['./store-info.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [NgSelectModule, SelectAccessibilityDirective, FocusDirective, FormsModule, NgClass],
})
export class StoreInfoComponent implements OnInit, AfterContentInit, OnDestroy {
    @Input() formField: Field | ClientField;

    @ViewChild('select') selectElement: NgSelectComponent;

    isMobileOrTabletDevice = HelperService.isMobileOrTabletDevice;
    regionStores = [];
    stores = [];

    private unsubscriber = new Subject<void>();

    constructor(
        private config: NgSelectConfig,
        public formService: FormService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
        this.config.notFoundText = 'No results found';
    }

    ngOnInit() {
        this.formField.valueModel = [];
    }

    ngAfterContentInit() {
        // fix for error: Expression has changed after it was checked. Previous value for 'focusableSelectElement': 'undefined'. Current value: '[object Object]'
        this.changeDetectorRef.detectChanges();
    }

    onSelect(item, type) {
        switch (type) {
            case 'brand': {
                if (item) {
                    this.getRegionList(item.value);
                    this.formField.valueModel.length = 1;
                } else {
                    this.formField.valueModel.length = 0;
                }
                break;
            }
            case 'region': {
                if (item) {
                    this.regionStores = item.stores;
                    this.formField.valueModel.length = 2;
                } else {
                    this.formField.valueModel.length = 2;
                }
                break;
            }
        }
    }

    onSelectFromMobile(itemValue: string, type: string, possibleValues) {
        const item = possibleValues.find((possibleValue) => {
            return possibleValue.value === itemValue;
        });

        this.onSelect(item, type);
    }

    private getRegionList(name) {
        this.formService
            .getStoresByBrand(name)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data) => {
                this.stores = data;
            });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
